export default __webpack_public_path__ + "static/pic05-b31a204b88a558e18ec699be78d2773e.jpg";